import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class extends BaseModule {
  constructor(m) {
    super(m)
  }

  init() {
    const blocks = document.querySelectorAll('[block-cta-button], [block-faq]')
    blocks.forEach((block) => {
      this.el.appendChild(block)
      block.classList.add('lg:col-start-1')
      block.classList.add('lg:col-end-3')
      block.classList.remove('hidden')
    })

    this.sticky()
  }

  sticky() {
    const medias = document.querySelector('[data-post="medias"]')
    const content = document.querySelector('[data-post="content"]')

    if (!medias || !content) return
    if (window.innerWidth < 900) return

    // get the height of the content and medias and check which one is the tallest
    const contentHeight = content.offsetHeight
    const mediasHeight = medias.offsetHeight

    let tallest
    let smallest
    if (contentHeight > mediasHeight) {
      tallest = content
      smallest = medias
    } else {
      tallest = medias
      smallest = content
    }

    // const header = document.querySelector('#header')
    // console.log('tallest', tallest)
    // console.log('smallest', smallest)

    // pin the smallest one to the tallest with scrolltrigger pin
    ScrollTrigger.create({
      trigger: smallest,
      start: () => 'bottom bottom-=64px',
      end: 'bottom bottom',
      endTrigger: tallest,
      pin: true,
      pinSpacing: false,
      // markers: true,
    })
  }
}
